import { render, staticRenderFns } from "./TheCart.vue?vue&type=template&id=6936a5c0&"
import script from "./TheCart.vue?vue&type=script&lang=js&"
export * from "./TheCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports